module.exports = __webpack_public_path__ + "assets/images/6c12f9da53e76e2bccc9aadbbcdf6adc.png";